"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFastenerMetadata = exports.deleteFastenersForConnectionByUUID = exports.updateFastenersForConnectionByUUID = exports.updateFastenersForConnection = exports.updateCombinedFastenersForConnection = exports.updateConnectionDataAfterFastenersVisualization = exports.removeFastenersForConnectionByUUID = exports.removeFastenersForConnection = exports.clearFastenersVisualizationDataForIConnection = exports.validateScrewFastenersToExtrusionMatch = exports.getConnectedExtrusionWidthByConnectionUUID = exports.loadFile = void 0;
/* eslint-disable no-param-reassign */
const types_1 = require("~/store/types");
const consts_1 = require("~/store/consts");
const ConnectionUtils_3d_1 = require("./ConnectionUtils.3d");
const Viewer_1 = __importDefault(require("../Viewer"));
function loadFile(item) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const drcLoader = Viewer_1.default.instance.getDesignProMain().loader;
            return yield drcLoader.loadFile(item);
        }
        catch (_a) {
            return null;
        }
    });
}
exports.loadFile = loadFile;
function getConnectedExtrusionWidthByConnectionUUID(connectionUUID) {
    var _a;
    const viewer = Viewer_1.default.instance;
    const connectionObject = viewer.getObjectById(connectionUUID);
    if (!connectionObject) {
        return 0;
    }
    const connection = connectionObject.getConnection();
    const connectedItem = connection.items.find(({ connectedSide, itemType, isMain }) => connectedSide === types_1.CONNECTED_FACE.SIDE && itemType === types_1.ITEM_TYPE.EXTRUSION && !isMain);
    if (!connectedItem) {
        return 0;
    }
    return (_a = connectedItem.extrusionWidth) !== null && _a !== void 0 ? _a : 0;
}
exports.getConnectedExtrusionWidthByConnectionUUID = getConnectedExtrusionWidthByConnectionUUID;
function validateScrewFastenersToExtrusionMatch(uuid, fastenerItem) {
    if (fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.recommendedScrewFasteners) {
        const extrusionWidth = getConnectedExtrusionWidthByConnectionUUID(uuid);
        const idx = fastenerItem.recommendedScrewFasteners.findIndex(
        // eslint-disable-next-line camelcase
        ({ profile_width }) => profile_width >= extrusionWidth);
        if (idx === -1) {
            return false;
        }
    }
    return true;
}
exports.validateScrewFastenersToExtrusionMatch = validateScrewFastenersToExtrusionMatch;
function clearFastenersVisualizationDataForIConnection(connection) {
    connection.distanceToTheEdge = undefined;
    connection.fastenerItemNumber = undefined;
    connection.numberOfFasteners = 0;
    connection.numberOfSlotsWithFastenersOnConnectedExtrusion = [];
    connection.fastenersMetadata = [];
}
exports.clearFastenersVisualizationDataForIConnection = clearFastenersVisualizationDataForIConnection;
function handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionType = types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.DO_NOTHING) {
    if (actionType === types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.APPLY_SPHERE) {
        clearFastenersVisualizationDataForIConnection(connectionObject.getConnection());
        connectionObject.removeFasteners();
        (0, ConnectionUtils_3d_1.addSphereToConnection)(mainObject, connectedObject, connectionObject, Viewer_1.default.instance.props.selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS);
    }
    return connectionObject;
}
function removeFastenersForConnection(connectionObject) {
    connectionObject.removeSphere();
    connectionObject.removeFasteners();
}
exports.removeFastenersForConnection = removeFastenersForConnection;
function removeFastenersForConnectionByUUID(connectionUUID) {
    const connectionObject = Viewer_1.default.instance.getObjectById(connectionUUID);
    if (!connectionObject) {
        return;
    }
    removeFastenersForConnection(connectionObject);
}
exports.removeFastenersForConnectionByUUID = removeFastenersForConnectionByUUID;
function updateConnectionDataAfterFastenersVisualization(connection, fastenerItemNumber, fastenerVisualizationResult, connectionObject, distanceToTheEdge) {
    var _a, _b;
    connection.fastenerItemNumber = fastenerItemNumber;
    connection.numberOfFasteners = fastenerVisualizationResult.fasteners.length;
    connection.fastenersMetadata = connectionObject.getFastenersMetadata();
    connection.numberOfSlotsWithFastenersOnConnectedExtrusion =
        (_a = fastenerVisualizationResult.slotsOnConnectedExtrusionForGroupA) === null || _a === void 0 ? void 0 : _a.map((slot) => slot.slotNumber);
    connection.numberOfSlotsWithFastenersOnMainExtrusion =
        (_b = fastenerVisualizationResult.slotNumbersOnMainExtrusionWithDistanceToSnappingPoint) === null || _b === void 0 ? void 0 : _b.map((item) => item.slotNumber);
    connection.distanceToTheEdge = distanceToTheEdge;
    if (connection.connectionType === types_1.CONNECTION_TYPE.END_TO_END) {
        connection.numberOfSlotsWithFastenersOnMainExtrusion =
            fastenerVisualizationResult.slotNumbersOnMainExtrusionForEndToEnd;
        connection.numberOfSlotsWithFastenersOnConnectedExtrusion =
            fastenerVisualizationResult.slotNumbersOnConnectedExtrusionForEndToEnd;
    }
    const connectedItem = connection.items.find((item) => !item.isMain);
    if (connectedItem) {
        connectedItem.slotNumbersWithDistanceToSnappingPoint =
            fastenerVisualizationResult.slotNumbersOnMainExtrusionWithDistanceToSnappingPoint;
    }
}
exports.updateConnectionDataAfterFastenersVisualization = updateConnectionDataAfterFastenersVisualization;
function updateCombinedFastenersForConnection(mainObject, connectedObject, mainItem, connectedItem, connectionObject, fastenerItems, actionTypeOnFailure = types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.DO_NOTHING) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const viewer = Viewer_1.default.instance;
        const connection = connectionObject.getConnection();
        const catalog = viewer.props.catalogItems;
        const { connectionType } = connection;
        if (fastenerItems.length === 0) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionTypeOnFailure);
        }
        const fastenerPrototypes = (yield Promise.all(fastenerItems.map((fastenerItem) => __awaiter(this, void 0, void 0, function* () {
            const catalogItem = catalog.find((item) => item.item_number === fastenerItem.item_number);
            if (!catalogItem) {
                return undefined;
            }
            const fastenerPrototype = (yield loadFile(catalogItem));
            if (!fastenerPrototype) {
                return undefined;
            }
            fastenerPrototype.initBoxes();
            const { distanceToTheEdge: distanceToTheEdgeProp, holeDepth: holeDepthProp, slotNumber } = fastenerItem || {};
            const distanceToTheEdge = (distanceToTheEdgeProp !== null && distanceToTheEdgeProp !== void 0 ? distanceToTheEdgeProp : fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.distanceToTheEdge);
            fastenerPrototype.distanceToTheEdge = distanceToTheEdge;
            fastenerPrototype.slotNumber = slotNumber;
            const holeDepth = Number(holeDepthProp !== null && holeDepthProp !== void 0 ? holeDepthProp : fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.holeDepth) || 0;
            fastenerPrototype.partDetails.holeDepth = holeDepth;
            return fastenerPrototype;
        })))).filter((fastener) => !!fastener);
        if (fastenerPrototypes.length === 0) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.APPLY_SPHERE);
        }
        connectionObject.hideFasteners();
        const fastenerVisualizationResult = connectionType === types_1.CONNECTION_TYPE.END_TO_END ||
            connectionType === types_1.CONNECTION_TYPE.ANGLED ||
            connectionType === types_1.CONNECTION_TYPE.PERPENDICULAR
            ? (0, ConnectionUtils_3d_1.tryToVisualizeCombinedFasteners)(mainObject, connectedObject, connectedItem, connectionType, fastenerPrototypes)
            : (0, ConnectionUtils_3d_1.tryToVisualizeFasteners)(mainObject, connectedObject, mainItem, connectedItem, connectionType, fastenerPrototypes[0]);
        connectionObject.showFasteners();
        if (!fastenerVisualizationResult) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionTypeOnFailure);
        }
        removeFastenersForConnection(connectionObject);
        connectionObject.addFasteners(fastenerVisualizationResult.fasteners);
        const distanceToEdge = (_a = fastenerItems.find((fastener) => fastener.distanceToTheEdge)) === null || _a === void 0 ? void 0 : _a.distanceToTheEdge;
        updateConnectionDataAfterFastenersVisualization(connection, fastenerItems[0].item_number, fastenerVisualizationResult, connectionObject, distanceToEdge !== null && distanceToEdge !== void 0 ? distanceToEdge : undefined);
        return connectionObject;
    });
}
exports.updateCombinedFastenersForConnection = updateCombinedFastenersForConnection;
function updateFastenersForConnection(mainObject, connectedObject, connectionObject, fastenerItemNumber, visualizationParams, actionTypeOnFailure = types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.DO_NOTHING) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const viewer = Viewer_1.default.instance;
        const connection = connectionObject.getConnection();
        const mainItem = connection.items.find((item) => item.isMain);
        const connectedItem = connection.items.find((item) => !item.isMain);
        if (!mainItem || !connectedItem) {
            return connectionObject;
        }
        const defaultFasteners = viewer.props.defaultProjectFasteners;
        const catalog = viewer.props.catalogItems;
        const [mainObjectSeries] = mainObject.partDetails.seriesIds;
        const { connectionType } = connection;
        const fastenerItem = (_a = defaultFasteners === null || defaultFasteners === void 0 ? void 0 : defaultFasteners[mainObjectSeries]) === null || _a === void 0 ? void 0 : _a[connectionType];
        let itemNumber = fastenerItemNumber !== null && fastenerItemNumber !== void 0 ? fastenerItemNumber : fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.item_number;
        if (connection.isDeletedFastener) {
            itemNumber = undefined;
        }
        if (!itemNumber) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionTypeOnFailure);
        }
        const catalogItem = catalog.find((item) => item.item_number === itemNumber);
        if (!catalogItem) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionTypeOnFailure);
        }
        if (!validateScrewFastenersToExtrusionMatch(connectionObject.uuid, fastenerItem) &&
            (fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.item_number) === itemNumber) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionTypeOnFailure);
        }
        const fastenerPrototype = (yield loadFile(catalogItem));
        if (!fastenerPrototype) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.APPLY_SPHERE);
        }
        fastenerPrototype.initBoxes();
        const { distanceToTheEdge: distanceToTheEdgeProp, holeDepth: holeDepthProp } = visualizationParams || {};
        const distanceToTheEdge = (distanceToTheEdgeProp !== null && distanceToTheEdgeProp !== void 0 ? distanceToTheEdgeProp : fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.distanceToTheEdge);
        fastenerPrototype.distanceToTheEdge = distanceToTheEdge;
        const holeDepth = Number(holeDepthProp !== null && holeDepthProp !== void 0 ? holeDepthProp : fastenerItem === null || fastenerItem === void 0 ? void 0 : fastenerItem.holeDepth) || 0;
        fastenerPrototype.partDetails.holeDepth = holeDepth;
        connectionObject.hideFasteners();
        const fastenerVisualizationResult = (0, ConnectionUtils_3d_1.tryToVisualizeFasteners)(mainObject, connectedObject, mainItem, connectedItem, connectionType, fastenerPrototype);
        connectionObject.showFasteners();
        if (!fastenerVisualizationResult) {
            return handleFastenerVisualizationFailure(mainObject, connectedObject, connectionObject, actionTypeOnFailure);
        }
        removeFastenersForConnection(connectionObject);
        connectionObject.addFasteners(fastenerVisualizationResult.fasteners, true, false);
        updateConnectionDataAfterFastenersVisualization(connection, itemNumber, fastenerVisualizationResult, connectionObject, distanceToTheEdge);
        return connectionObject;
    });
}
exports.updateFastenersForConnection = updateFastenersForConnection;
function updateFastenersForConnectionByUUID(connectionUUID, fastenerItemNumber, visualizationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const viewer = Viewer_1.default.instance;
        const connectionObject = viewer.getObjectById(connectionUUID);
        if (!connectionObject) {
            return null;
        }
        const mainObject = connectionObject.getMainObject();
        const connectedObject = connectionObject.getConnectedObject();
        return updateFastenersForConnection(mainObject, connectedObject, connectionObject, fastenerItemNumber, visualizationParams);
    });
}
exports.updateFastenersForConnectionByUUID = updateFastenersForConnectionByUUID;
function deleteFastenersForConnectionByUUID(connectionUUID) {
    const viewer = Viewer_1.default.instance;
    const connectionObject = viewer.getObjectById(connectionUUID);
    if (!connectionObject) {
        return null;
    }
    const connection = connectionObject.getConnection();
    connection.isDeletedFastener = true;
    const mainObject = connectionObject.getMainObject();
    const connectedObject = connectionObject.getConnectedObject();
    clearFastenersVisualizationDataForIConnection(connection);
    connectionObject.removeFasteners();
    (0, ConnectionUtils_3d_1.addSphereToConnection)(mainObject, connectedObject, connectionObject, Viewer_1.default.instance.props.selectedTool === consts_1.TOOL_STATE.SHOW_FASTENERS);
    return connectionObject;
}
exports.deleteFastenersForConnectionByUUID = deleteFastenersForConnectionByUUID;
function setFastenerMetadata(fastener, fastenerItem) {
    var _a, _b;
    fastener.initBoxes();
    const { distanceToTheEdge, holeDepth } = fastenerItem;
    fastener.distanceToTheEdge = (_a = distanceToTheEdge !== null && distanceToTheEdge !== void 0 ? distanceToTheEdge : fastener.distanceToTheEdge) !== null && _a !== void 0 ? _a : undefined;
    fastener.partDetails.holeDepth = (_b = holeDepth !== null && holeDepth !== void 0 ? holeDepth : fastener.partDetails.holeDepth) !== null && _b !== void 0 ? _b : 0;
}
exports.setFastenerMetadata = setFastenerMetadata;
